module.exports = __webpack_public_path__ + "static/media/icon-go-top.4ecaf28f.svg";